<template>
  <div class="">
    <h4 class="text-left">Tankers:</h4>
    <div class="row">
    <ShipTile v-for="ship in tankers" :ship="ship"  @onSelectShip="handleSelectShip"/>
    </div>
    <h4 class="text-left">Bulk Carriers:</h4>
    <div class="row">
    <ShipTile v-for="ship in bulkCarriers" :ship="ship" @onSelectShip="handleSelectShip"/>
    </div>
    <h4 class="text-left">Ro-Ro:</h4>
    <div class="row">
    <ShipTile v-for="ship in roro" :ship="ship" @onSelectShip="handleSelectShip"/>
    </div>
    <h4 class="text-left">Passenger/Cruise:</h4>
    <div class="row">
    <ShipTile v-for="ship in paxCruise" :ship="ship" @onSelectShip="handleSelectShip"/>
    </div>
      </div>
</template>

<script>
import ShipTile from "./ShipTile.vue";

export default {
  name: "ShipSelector",
  components: {
    ShipTile
  },
  props: {
    ships: Array
  },
  computed: {
    tankers: function() {
        return this.ships.filter(function (el) {return el.type === 'tanker'})
    },
    bulkCarriers: function() {
        return this.ships.filter(function (el) {return el.type === 'bulk carrier'})
    },
    roro: function() {
        return this.ships.filter(function (el) {return el.type === 'ro-ro'})
    },
    paxCruise: function() {
        return this.ships.filter(function (el) {return el.type === 'pax'})
    }
  },
  methods: {
    handleSelectShip: function(ship,customise) {
      // console.log(ship,customise)
      this.$emit("onSelectShip", ship, customise);
    }
  }
};
</script>

<style scoped>
</style>